import React from 'react';
import * as S from './TooltipComponent.styled';

const TooltipComponent = React.forwardRef(function MyComponent(props, ref) {
  return (
    <S.Container {...props} ref={ref}>
      {props.render}
    </S.Container>
  );
});

export default TooltipComponent;
